import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Principal from './components/principal';
import Login from './pages/login';
import PrivateRoute from './PrivateRoute';




const Routes = () => (
        <Switch>
            <PrivateRoute exact path='/' component={Principal} />
            <Route exact path='/login' component={Login} />
        </Switch>
)

export default Routes;